module.exports = __webpack_public_path__ + "static/bg-d680247df33e79297fbca540f05973a7.mp4";